import * as Tooltip from "@radix-ui/react-tooltip";
import styles from "./CheckboxWithTooltip.module.css";
import React from "react";
import InfoTooltip from "./InfoTooltip";

interface CheckboxWithTooltipProps {
  id: string;
  tooltipLabel: string;
  tooltipContent: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxWithTooltip: React.FC<CheckboxWithTooltipProps> = ({
  id,
  tooltipLabel,
  tooltipContent,
  description,
  checked,
  disabled = false,
  onChange,
}) => {
  return (
    <Tooltip.Provider>
      <div className={styles["checklist-item"]}>
        <div className={styles["checkbox-input-container"]}>
          <input
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
          />
          <label htmlFor={id} className={styles["checkbox-title"]}>
            {description}
          </label>
          <InfoTooltip
            tooltipLabel={tooltipLabel}
            tooltipContent={tooltipContent}
            disabled={disabled}
          />
        </div>
      </div>
    </Tooltip.Provider>
  );
};

export default CheckboxWithTooltip;
